import _ from "lodash";

const YOUTUBE_URL_VALIDATION_RE = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=&v=|\?v=)([^#&?]*).*/;

/** returns video id if it's a valid youtube video url or else it returns null */
export const getYoutubeVideoId = url => {
  const match = url.match(YOUTUBE_URL_VALIDATION_RE);

  if (match && _.isEqual(_.get(match, "[2].length"), 11)) {
    return match[2];
  } else {
    return null;
  }
};
